import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { foTitle, foList, guoxueList0, shopInGuoxue, guoxueList1 },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip id="200145" type="struct" title="佛教国学标题" groupName="佛教国学" content={foTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="255873"
                    type="recommend"
                    title="佛教列表"
                    groupName="佛教国学"
                    content={foList}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                <Chip
                    id="255874"
                    type="recommend"
                    title="国学列表1"
                    groupName="佛教国学"
                    content={guoxueList0}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="225760"
                    type="recommend"
                    title="国学区电商"
                    groupName="佛教国学"
                    content={shopInGuoxue}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="225761"
                    type="recommend"
                    title="国学列表2"
                    groupName="佛教国学"
                    content={guoxueList1}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
